import { AccordionCustom } from './accordion-custom.js';

class FaqSearch extends HTMLElement {
  connectedCallback() {
    this.searchInput = this.querySelector('.js-search-faq-page');
    this.clearButton = this.querySelector('.search__icon--clear');
    this.searchButton = this.querySelector('.search__icon--faq');
    this.accordionCollections = document.querySelectorAll('faq-accordion');
    if (!this.searchInput) return;
    this.searchInput.addEventListener('input', this.handleSearch);
    this.clearButton?.addEventListener('click', this.clearSearch);
    this.clearButton?.addEventListener('mousedown', (e) => {
      e.preventDefault();
    });

    this.searchButton?.addEventListener('click', () => {
      if (this.clearButton) {
        this.clearButton.style.display = 'none';
      }
    });

    this.searchInput.addEventListener('focus', () => {
      if (this.clearButton && this.searchInput.value) {
        this.clearButton.style.display = 'flex';
      }
    });

    // Hide clear button when losing focus
    this.searchInput.addEventListener('blur', () => {
      if (this.clearButton) this.clearButton.style.display = 'none';
    });
  }

  handleSearch = () => {
    const searchTerm = this.searchInput.value;

    if (this.clearButton) {
      this.clearButton.style.display = searchTerm ? 'flex' : 'none';
    }

    this.accordionCollections.forEach((collection) => {
      collection.findMatchingAccordions?.(searchTerm);
    });
  };

  clearSearch = () => {
    this.searchInput.value = '';
    this.searchInput.focus();

    if (this.clearButton) this.clearButton.style.display = 'none';

    this.accordionCollections.forEach((collection) => {
      collection.findMatchingAccordions?.('');
    });
  };
}

if (!customElements.get('faq-search')) {
  customElements.define('faq-search', FaqSearch);
}

class FaqAccordion extends AccordionCustom {
  constructor() {
    super();
    this.hiddenAccords = 0;
  }

  connectedCallback() {
    super.connectedCallback();

    this.accordions = this.querySelectorAll('details');
    this.accordionCount = this.accordions.length;

    this.accordions.forEach((accordion) => {
      accordion.addEventListener('toggle', () => {
        if (accordion.open) {
          this.accordions.forEach((other) => {
            if (other !== accordion) {
              other.open = false;
            }
          });
        }
      });
    });
  }

  findMatchingAccordions(searchString) {
    this.hiddenAccords = 0;

    if (searchString === '') {
      this.classList.remove('hidden');
      this.accordions.forEach((accordion) => {
        accordion.classList.remove('hidden');
      });
      return;
    }

    this.accordions.forEach((accordion) => {
      const headText = accordion.querySelector('.details__header').textContent;
      const contentText = accordion.querySelector('.details-content').textContent;

      const combinedText = (headText + ' ' + contentText).toLowerCase();
      const shouldHide = !combinedText.includes(searchString.toLowerCase());
      accordion.classList.toggle('hidden', shouldHide);
      if (shouldHide) this.hiddenAccords += 1;
    });

    if (this.hiddenAccords === this.accordionCount) {
      this.classList.add('hidden');
    } else {
      this.classList.remove('hidden');
    }
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}
